export default function Footer() {
  return (
    <footer className="py-10 text-center text-sm text-white bg-main-blue border-2 border-white border-x-0 border-b-0">
      © {new Date().getFullYear()} Mancobe — Todos os direitos reservados.
    </footer>
  );
}
